export default "__VITE_ASSET__CBGs3_vO__"